export interface LegalArticle {
  title: string;
  content: {
    mainText?: string;
    bulletPoints?: string[];
    additionalText?: string[];
    contactInfo?: string;
  }[];
}

export const legalData: LegalArticle[] = [
  {
    title: "Mentions légales",
    content: [
      {
        mainText: "Dernière mise à jour : 23 mars 2026.",
      },
      {
        bulletPoints: [
          "Site : https://www.espacecadet.com",
          "Marque exploitée : Espace Cadet",
          "Éditeur et responsable de publication : BAC APPS",
          "Contact éditeur : clementine@espacecadet.com",
          "Directrice de publication : Clémentine BARBIER (CHEVET), gérante",
        ],
      },
    ],
  },
  {
    title: "Informations juridiques de BAC APPS (Espace Cadet)",
    content: [
      {
        bulletPoints: [
          "Dénomination : BAC APPS",
          "Forme juridique : SARL unipersonnelle",
          "SIREN : 790 826 937",
          "SIRET (siège) : 790 826 937 00019",
          "RCS : 790 826 937 R.C.S. Paris",
          "TVA intracommunautaire : FR18 790 826 937",
          "Adresse du siège : 5 rue Marguerite de Rochechouart, 75009 Paris, France",
          "Code APE : 68.20B",
          "Dirigeante déclarée : Clémentine BARBIER (CHEVET), gérante",
        ],
      },
      {
        additionalText: [
          "Source de vérification : Annuaire des entreprises (data.gouv.fr), consultation du 23 mars 2026.",
          "Le site présente les offres de coworking et de location de bureaux d'Espace Cadet. Aucune vente en ligne n'est réalisée directement sur le site.",
        ],
      },
    ],
  },
  {
    title: "Conception et développement technique",
    content: [
      {
        bulletPoints: [
          "Société : NEXT GENERATION",
          "Forme juridique : SAS",
          "SIREN : 992 331 322",
          "SIRET (siège) : 992 331 322 00014",
          "Adresse du siège : 60 rue François Ier, 75008 Paris, France",
          "Code APE : 62.02A",
          "Dirigeants déclarés : Meymoun Abdallah BOUALAOUI (Président), Mael Antonio Denis DAMOTTE DA SILVA (Directeur Général)",
          "Site web : https://www.next-generation.dev",
          "Contact technique : contact@next-generation.dev",
        ],
      },
      {
        additionalText: [
          "Next Generation intervient en qualité de prestataire technique du site et de sous-traitant sur les opérations strictement techniques.",
        ],
      },
    ],
  },
  {
    title: "Hébergement",
    content: [
      {
        bulletPoints: [
          "Hébergeur : Vercel Inc.",
          "Adresse : 440 N Barranca Avenue #4133, Covina, CA 91723, USA",
          "Site web : https://vercel.com",
          "Contact vie privée : privacy@vercel.com",
        ],
      },
      {
        additionalText: [
          "Le stockage et certains traitements techniques peuvent impliquer des transferts hors Union européenne, encadrés contractuellement par les prestataires.",
        ],
      },
    ],
  },
  {
    title: "Protection des données personnelles (RGPD)",
    content: [
      {
        mainText:
          "Les détails de traitement sont disponibles sur la page Politique de confidentialité. En résumé :",
      },
      {
        bulletPoints: [
          "Responsable de traitement : BAC APPS",
          "Finalités principales : gestion des demandes de contact et échanges commerciaux",
          "Base légale : mesures précontractuelles et intérêt légitime",
          "Données traitées : nom, email, téléphone (optionnel), message",
          "Destinataires : équipe Espace Cadet et prestataires techniques nécessaires (hébergement, envoi d'emails)",
          "Droits : accès, rectification, effacement, opposition, limitation, portabilité",
        ],
      },
      {
        contactInfo:
          "Pour exercer vos droits : clementine@espacecadet.com (copie possible à contact@next-generation.dev)",
      },
      {
        additionalText: [
          "Vous pouvez également introduire une réclamation auprès de la CNIL : https://www.cnil.fr/fr/plaintes",
        ],
      },
    ],
  },
  {
    title: "Propriété intellectuelle",
    content: [
      {
        mainText:
          "L'ensemble des contenus (textes, éléments graphiques, logo, photos, structure du site) est protégé par le droit de la propriété intellectuelle.",
      },
      {
        bulletPoints: [
          "Les contenus appartenant à BAC APPS ou à des tiers autorisés ne peuvent pas être reproduits sans autorisation écrite préalable.",
          "Toute réutilisation non autorisée peut engager la responsabilité civile et/ou pénale de son auteur.",
        ],
      },
    ],
  },
  {
    title: "Responsabilité et droit applicable",
    content: [
      {
        bulletPoints: [
          "BAC APPS et Next Generation s'efforcent d'assurer l'exactitude des informations publiées, sans garantir l'absence totale d'erreurs ou d'interruptions.",
          "Les liens externes sont fournis à titre informatif ; leur contenu reste sous la responsabilité de leurs éditeurs respectifs.",
          "Le site et ses mentions légales sont soumis au droit français.",
        ],
      },
    ],
  },
];
